//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LazyLoadSelect',
  props: {
    value: {
      type: [String, Number, Object, null],
      default: null
    },
    label: String,
    hint: String,
    disabled: Boolean,
    searchable: {
      type: Boolean,
      default: true
    },
    optionLabel: {
      type: [String, Function],
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    fetchData: {
      type: Function,
      required: true
    },
    fetchSingle: {
      type: Function,
      required: false
    },
    debounce: {
      type: Number,
      default: 300
    },
    inputDebounce: {
      type: Number,
      default: 300
    },
    noOptionsText: {
      type: String,
      default: 'Ingen resultat'
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      selectedValue: null,
      options: [],
      loading: false,
      currentSearch: '',
      currentPage: 1,
      pageSize: 50,
      totalPages: 1,
      initialLoadDone: false,
      filtering: false,
      internalDisabled: false
    };
  },
  methods: {
    async loadData(page = 1, searchQuery = '') {
      if (!this.fetchData) return;

      this.loading = true;
      this.filtering = Boolean(searchQuery);

      try {
        const response = await this.fetchData({
          pageNumber: page,
          pageSize: this.pageSize,
          searchQuery
        });

        if (page === 1) {
          this.options = response.items;
        } else {
          const merged = [...this.options, ...response.items];
          const distinctMap = new Map();

          merged.forEach(item => {
            distinctMap.set(item[this.optionValue], item);
          });

          this.options = Array.from(distinctMap.values());
        }

        this.totalPages = response.totalPages;
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.loading = false;
      }
    },

    async onFilter(value, update) {
      this.currentSearch = value;
      this.currentPage = 1;

      if (value.length > 0) {
        await this.loadData(this.currentPage, value);
      } else {
        await this.loadData(this.currentPage);
      }

      update();
    },
    onFilterAbort() {
      this.filtering = false;
    },
    onFocus() {
      if (!this.initialLoadDone) {
        this.initialLoadDone = true;
        this.currentPage = 1;
        this.loadData(this.currentPage);
      }
    },
    async onVirtualScroll({ to, ref }) {
      const lastIndex = this.options.length - 1;
      if (!this.loading && this.currentPage < this.totalPages && to === lastIndex) {
        this.currentPage++;
        await this.loadData(this.currentPage, this.currentSearch);
        ref && ref.refresh();
      }
    },
    onSelectUpdate(val) {
      this.selectedValue = val;
      this.$emit('input', val);
    },
  },

  async mounted() {
    if (!this.value || !this.fetchSingle || this.value === -1) return;
    this.internalDisabled = true;
    this.loading = true;
    try {
      var item = await this.fetchSingle(this.value)
      this.options = [item];
      this.selectedValue = this.value;
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      this.loading = false;
      this.internalDisabled = false;
    }
  }
};
